import React, { Fragment, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Loading from "../Loading";
import { useOrderDetails } from "./Hooks";
import { Helmet } from "react-helmet";
import WalletSharge from "./Components/WalletSharge";
import Reserve from "./Components/Reserve";
import JoinClass from "./Components/JoinClass";
import ContractualReservation from "./Components/ContractualReservation";
import InstallmentsContractualReservation from "./Components/InstallmentsContractualReservation";
import BoxShadow from "../BoxShadow";
import CustomModal from "../Modal/CustomModal";
import TimePicker from "../TimePicker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { Calendar } from "react-multi-date-picker";
import { ConvertDate } from "../../Function";
import { FormControlLabel, FormGroup, Switch, TextField } from "@mui/material";
import DetailPage from "../../../../App/Panel/OrderDetails/DetailPage";
import { RtlMui } from "../../../../App/component/rtlMui";
const OrderDetails = ({ isApp, role = false }) => {
  const location = useLocation();
  const [reason, setReason] = useState();
  const [updateAll, setUpdateAll] = useState(0);
  const [wage, setWage] = useState(false);

  const {
    user,
    getOrderDetails,
    details,
    loading,
    modal,
    setModal,
    isAbsent,
    isOtherPeople,
    setExpired,
    loadingBtn,
    confirm,
    refundOrder
  } = useOrderDetails(location.state && location.state.role);

  useEffect(() => {
    getOrderDetails();
  }, [updateAll]);
  const HandlerComponent = () => {
    switch (details.order.model_order) {
      case "walletsharge":
        return <WalletSharge data={details} />;
      case "reserve":
        return (
          <Reserve
            data={details}
            role={location.state && location.state.role}
            updateAll={updateAll}
            setUpdateAll={setUpdateAll}
            isAbsent={isAbsent()}
            appModal={() => setModal({ visible: true })}
          />
        );
      case "joinclass":
        return <JoinClass data={details} />;
      case "contractual_reservation":
        return (
          <ContractualReservation
            data={details}
            role={location.state && location.state.role}
            updateAll={updateAll}
            setUpdateAll={setUpdateAll}
            isAbsent={isAbsent()}
            appModal={() => setModal({ visible: true })}
          />
        );
      case "contractual_reservation_installments":
        return (
          <InstallmentsContractualReservation
            data={details}
            role={location.state && location.state.role}
            updateAll={updateAll}
            setUpdateAll={setUpdateAll}
            isAbsent={isAbsent()}
            appModal={() => setModal({ visible: true })}
          />
        );
    }
  };

  const navigate = useNavigate();

  if (isApp) {
    return (
      <>
        <DetailPage data={details} loading={loading.details} setExpired={setExpired} appModal={() => setModal({ visible: true })}
          updateAll={updateAll} setUpdateAll={setUpdateAll} refundOrder={refundOrder} isAbsent={isAbsent()} locRole={location?.state?.role} />
        <CustomModal
          size={"md"}
          show={modal.visible}
          header={isAbsent() ? "ثبت حضور" : "منقضی کردن"}
          handleClose={() => {
            setModal({ visible: false });
          }}
        >
          {!loading.details &&
            <RtlMui>

              {console.log(details)}
              <div className="appInputBox">
                <Modal
                  data={{
                    details,
                    isAbsent: isAbsent(),
                    isOtherPeople: isOtherPeople(),
                    order_id: details?.order?.order_id,
                  }}
                  modal={modal}
                  setModal={setModal}
                  setExpired={setExpired}
                  loadingBtn={loadingBtn}
                  confirm={confirm}
                  isApp={isApp}
                />
              </div>
            </RtlMui>
          }
        </CustomModal>
      </>
    )
  }

  if (loading.details) {
    return <Loading count={1} col={12} height={500} />;
  }
  return (
    <Fragment>
      <Helmet>
        <title>نیکوتن | جزییات سفارش</title>
      </Helmet>
      <div className="col-12">
        <BoxShadow>
          <div className="row justify-content-between">
            <div className="col-md-6">
              <h4>جزییات کامل سفارش</h4>
            </div>
            <div className="col-md-6 d-flex justify-content-end">
              <button
                className="btn btn-primary mr-2"
                onClick={() => {
                  navigate(-1);
                }}
              >
                بازگشت به لیست
              </button>
              {location?.state?.role == "user" || user.role == "user" ? (
                <>
                  <button
                    className="btn btn-primary"
                    onClick={() => {
                      navigate(`/ticket?pay=${details.order.peykey}`);
                    }}
                  >
                    مشاهده بلیت
                  </button>
                  <button className="btn btn-primary mr-2"
                    onClick={() => {
                      refundOrder(details.order.order_id);
                    }}
                  >
                    استرداد سفارش
                  </button>
                </>
              ) : (
                <>
                  {user.role == "manager" && details.order.status != "used" ? (
                    <button
                      className="btn btn-primary"
                      onClick={() => {
                        setModal({
                          visible: true,
                        });
                      }}
                    >
                      {isAbsent() ? "ثبت حضور" : "منقضی کردن"}
                    </button>
                  ) : (
                    <></>
                  )}
                </>
              )}
              {user.role == "owner" ? details.peyment.status == "peyed"
                ? (
                  <>
                    <button className="btn btn-primary mr-2"
                      onClick={() => {
                        setModal({ visibleRefund: true });
                        // refundOrder(details.order.order_id, role = "admin");
                      }}
                    >
                      لغو سفارش
                    </button>
                    <CustomModal
                      size={"md"}
                      show={modal.visibleRefund}
                      header={"لغو سفارش"}
                      handleClose={() => {
                        setModal({ visibleRefund: false });
                      }}
                    >
                      <div className={`mt-2 mb-3`}>
                        <TextField size="small" label="دلیل لغو" className="w-100"
                          onChange={(e) => setReason(e.target.value)} />
                      </div>

                      <div className="d-flex align-items-center my-3">
                        <p className="mb-0 ml-2 mr-4">کسر کارمزد از  حساب مجموعه</p>
                        <FormGroup>
                          <FormControlLabel size="sm" control={<Switch defaultChecked />} checked={wage}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setWage(true);
                              }
                              else {
                                setWage(false);
                              }
                            }} />
                        </FormGroup>
                      </div>

                      <button className="btn btn-primary px-4"
                        onClick={() => {
                          refundOrder(details.order.order_id, role = "admin", reason, wage);
                          setModal({ visibleRefund: false });
                        }}
                      >
                        ثبت
                      </button>

                    </CustomModal>
                  </>
                )
                : (
                  <button className="btn btn-primary mr-2"
                    onClick={() => {
                      // refundOrder(details.order.order_id, role = "admin");
                    }}
                  >
                    حذف سفارش
                  </button>

                ) : null}
            </div>
          </div>

          <div>{HandlerComponent()}</div>
          <CustomModal
            size={"md"}
            show={modal.visible}
            header={isAbsent() ? "ثبت حضور" : "منقضی کردن"}
            handleClose={() => {
              setModal({ visible: false });
            }}
          >

            <Modal
              data={{
                details,
                isAbsent: isAbsent(),
                isOtherPeople: isOtherPeople(),
                order_id: details.order.order_id,
              }}
              modal={modal}
              setModal={setModal}
              setExpired={setExpired}
              loadingBtn={loadingBtn}
              confirm={confirm}
            />
          </CustomModal>
        </BoxShadow>
      </div>
    </Fragment>
  );
};
const Modal = ({
  data: {
    details: { user_buyer },
    isAbsent,
    isOtherPeople,
    order_id,
  },
  modal,
  setModal,
  setExpired,
  loadingBtn,
  confirm,
  isApp
}) => {
  const { selected, setSelected, form, setForm, loading } = useOrderDetails();
  const [step, setStep] = useState(0);
  if (step) {
    switch (step) {
      case "date":
        return (
          <div>
            <h6>لطفا تاریخ و ساعت حضور را وارد کنید</h6>
            <div className="mt-4">
              <TimePicker
                form={form}
                setForm={setForm}
                element={{
                  key: "time",
                  name: "ساعت حضور",
                }}
              />{" "}
            </div>
            <div className={`my-2`}>
              <label
                // className={`${labelStyle ? "bg-success" : "bg-danger"}`}
                htmlFor=""
              >
                تاریخ حضور
              </label>
              <Calendar
                // range={true}
                onChange={data => {
                  setForm({
                    ...form,
                    date: ConvertDate(
                      `${data.year}/${data.month.number}/${data.day}`
                    ),
                  });
                }}
                calendar={persian}
                // multiple={true}
                locale={persian_fa}
              />
              <div className="mt-3 d-flex justify-content-center">
                <button
                  disabled={loading.absent}
                  onClick={() => {
                    if (isOtherPeople) {
                      setStep("selectUser");
                    } else {
                      confirm({
                        order_id,
                        type: "withdate",
                        reseves: user_buyer.reserve_id,
                        ...form,
                      });
                    }
                  }}
                  className={`btn d-flex justify-content-center btn-danger `}
                  style={{ width: "120px" }}
                >
                  {!loading.absent ? "ثبت" : "در حال ارسال"}
                </button>
              </div>
            </div>
          </div>
        );
      case "selectUser":
        return (
          <div>
            <div className="py-4">
              {isOtherPeople.map(
                ({ fullname, mobile, reserve_id, national_code }) => {
                  return (
                    <div
                      key={reserve_id}
                      className="d-flex justify-content-between border rounded p-2 my-1 align-items-center"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        selected.includes(reserve_id)
                          ? setSelected(
                            [...selected].filter(mo => mo !== reserve_id)
                          )
                          : setSelected([...selected, reserve_id]);
                      }} >
                      <div className=" p-2 d-flex flex-column my-1">
                        <div>{fullname}</div>
                        <div>{national_code}</div>
                        <div>{mobile}</div>
                      </div>
                      <div>
                        <button
                          className={`btn d-flex justify-content-center ${selected.includes(reserve_id)
                            ? "btn-success"
                            : "btn-danger"
                            }`}
                          style={{ width: "120px" }}
                        >
                          {selected.includes(reserve_id)
                            ? "انتخاب شده"
                            : "انتخاب"}
                        </button>
                      </div>
                    </div>
                  );
                }
              )}
            </div>
            <button
              className="btn btn-danger text-white px-3 btn-block"
              disabled={loading.absent || !selected.length}
              onClick={() => {
                if (form.date) {
                  confirm({
                    order_id,
                    type: "withdate",
                    reseves: isOtherPeople.map(user => user.reserve_id),
                    ...form,
                  });
                } else {
                  confirm({
                    order_id,
                    type: "now",
                    reseves: isOtherPeople.map(user => user.reserve_id),
                    ...form,
                  });
                }
              }}
            >
              {loading.absent ? "در حال پردازش" : "ثبت"}
            </button>
          </div>
        );
      default:
        return <>ddwads</>;
        break;
    }
  }
  if (isOtherPeople) {
    if (isAbsent) {
      return (
        <div className="d-flex justify-content-evenly">
          <div style={{ flex: 1 }}>
            <button
              className="btn btn-success"

              onClick={() => setStep("selectUser")}
            >
              اکنون
            </button>
          </div>
          <div>
            <button
              className="btn btn-danger"
              onClick={() => {
                setStep("date");
              }}
            >
              تاریخ دیگر
            </button>
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <div className="py-4">
            {isOtherPeople.map(
              ({ fullname, mobile, reserve_id, national_code }) => {
                return (
                  <div
                    key={reserve_id}
                    className="d-flex justify-content-between border rounded p-2 my-1 align-items-center"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      selected.includes(reserve_id)
                        ? setSelected(
                          [...selected].filter(mo => mo !== reserve_id)
                        )
                        : setSelected([...selected, reserve_id]);
                    }}
                  >
                    <div className=" p-2 d-flex flex-column my-1">
                      <div>{fullname}</div>
                      <div>{national_code}</div>
                      <div>{mobile}</div>
                    </div>
                    <div>
                      <button
                        className={`btn d-flex justify-content-center ${selected.includes(reserve_id)
                          ? "btn-success"
                          : "btn-danger"
                          }`}
                        style={{ width: "120px" }}
                      >
                        {selected.includes(reserve_id)
                          ? "انتخاب شده"
                          : "انتخاب"}
                      </button>
                    </div>
                  </div>
                );
              }
            )}
          </div>
          <button
            className="btn btn-danger text-white px-3 btn-block"
            disabled={loadingBtn || !selected.length}
            onClick={() => {
              setExpired({
                action:
                  selected.length === isOtherPeople.length
                    ? "full"
                    : "specific",
                order_id,
                reseves: selected,
              });
            }}
          >
            {loadingBtn ? "در حال پردازش" : "ثبت"}
          </button>
        </div>
      );
    }
  } else if (isAbsent) {
    return (
      <div className="d-flex justify-content-evenly">
        <div style={{ flex: 1 }}>
          <button
            className="btn btn-success"
            disabled={loadingBtn.absent}
            onClick={() =>
              confirm({
                order_id,
                type: "now",
                reseves: user_buyer.reserve_id,
              })
            }
          >
            اکنون
          </button>
        </div>
        <div>
          <button
            className="btn btn-danger"
            onClick={() => {
              setStep("date");
            }}
          >
            تاریخ دیگر
          </button>
        </div>
      </div>
    );
  } else {
    return (
      <div>
        <h5 className={isApp && "nfs-12"}>آیا مطمئن هستید‌؟‌</h5>
        <p className={isApp && "nfs-10 fw300 mb-3"} style={{ fontSize: "14px" }}>
          مدیر عزیز ،‌ با منقضی کردن بلیت ،‌ بلیت به عنوان استفاده شده در سامانه
          قرار میگیرد
        </p>
        <div className="d-flex ">
          <button
            className={"btn btn-success text-white px-3 " + (isApp && "flex-fill nfs-10")}
            disabled={loadingBtn}
            onClick={() => {
              setExpired({
                action: "full",
                order_id,
              });
            }}
          >
            {loadingBtn ? "در حال پردازش" : "بله"}
          </button>
          <button
            className={"btn btn-primary text-white mr-3 px-3 " + (isApp && "flex-fill")}
            onClick={() => {
              setModal({ visible: false });
            }}
          >
            خیر
          </button>
        </div>

      </div>
    );
  }
  return <div></div>;
};

export default OrderDetails;
